import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import data from '../data';
import Devices from './Devices';
import Toggle from './Toggle';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    noBorder: {
        borderBottom: 'none'
    }
});


class Clients extends React.PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    render = () => (
        <Toggle>{(isExtended, handleExtend) => (
            <Paper className={this.props.classes.root}>
                <Table className={this.props.classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Client</TableCell>
                            <TableCell>Contact</TableCell>
                            <TableCell numeric>Devices</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map(client => {
                            const result = [
                                <TableRow key={client.id}>
                                    <TableCell>
                                        <IconButton aria-label="Extend" onClick={handleExtend(client.id)}>
                                            {isExtended(client.id) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                        </IconButton>
                                        {client.name}
                                    </TableCell>
                                    <TableCell>{client.contact}</TableCell>
                                    <TableCell numeric>{client.devices.size}</TableCell>
                                </TableRow>
                            ];
                            if (isExtended(client.id) && client.devices.size) {
                                result.push(
                                    <TableRow key={`${client.id}-child`}>
                                        <TableCell className={this.props.classes.noBorder} colSpan={99}>
                                            <Devices data={client.devices} />
                                        </TableCell>
                                    </TableRow>
                                )
                            }

                            return result;
                        })}
                    </TableBody>
                </Table>
            </Paper>
            )}
        </Toggle>
    );
}



export default withStyles(styles)(Clients);


// WEBPACK FOOTER //
// ./src/modules/clients/src/components/Clients.js